export const error = {
  state: {
    menu: '',
    objects: '',
    favorites: '',
    mails: '',
    mailsSync: '',
  },

  mutations: {
    setMenuError(state, error) {
      state.menu = error
    },

    clearMenuError(state) {
      state.menu = ''
    },

    setObjectsError(state, error) {
      state.objects = error
    },

    clearObjectsError(state) {
      state.objects = ''
    },

    setFavoritesError(state, error) {
      state.favorites = error
    },

    clearFavoritesError(state) {
      state.favorites = ''
    },

    setMailsError(state, error) {
      state.mails = error
    },

    clearMailsError(state) {
      state.mails = ''
    },
  },
}
